import { useShallow } from "zustand/shallow";

import { useOnboardingStore } from "@/features/onboarding/stores";

export const useOnboardingUser = () => {
  return useOnboardingStore(useShallow((state) => state.getUser()));
};
